const languages = {
    'de': {
        'ACADEMY' : 'Academy',
        'AGREE_PRIVACY_POLICY' :  'Bitte bestätigen Sie unsere Datenschutzerklärung.',
        'ALSO_INTERESTING_FOR_YOU' : 'Für Sie interessant',
        'APPEARANCE' : 'Darstellung',
        'AREA' : 'Bereich',
        'ASSESSMENT' : 'Bewertung',
        'BACK_TO_DASHBOARD' : 'Zum Dashboard',
        'BACK_TO_LOGIN' : 'Zurück zum Login',
        'BENEFIT' : 'Nutzen',
        "BLOG" : "Aus unserem Blog",
        'CHAPTER' : 'Kapitel',
        'COLLECT_WEEKLY_DATA' : 'Wochendaten erfassen',
        'COLLECT_MONTHLY_DATA' : 'Monatsdaten erfassen',
        'COMPANIES' : 'Firmen',
        'COURSE_CONTENT' : 'Kursinhalt',
        'CREATED_AT' : 'Erstellt am',
        'CREATE_NEW_COMPANY' : 'Neue Firma anlegen',
        'CREATE_NEW_PRODUCT':  'Neues Produkt anlegen',
        'CREATE_NEW_PROJECT' : 'Neues Projekt anlegen',
        'CREATE_NEW_USER' : 'Neuen Nutzer anlegen',
        'CREATE_NEW_TRANSCRIPT' : 'Neues Transkript',
        'DELETE' : 'Löschen',
        'DESCRIPTION' : 'Beschreibung',
        'DONE' : 'Erledigt',
        'DOWNLOAD' : 'Download',
        'EFFORT' : 'Aufwand',
        'E_MAIL' : 'E-Mail-Adresse',
        'EMAIL_EXISTS_RESPONSE_TEXT' : 'Sie sind bereits registriert. Schauen Sie bitte in Ihr E-Mail-Postfach - wir haben Ihnen bereits eine E-Mail mit Ihren Zugangsdaten gesendet. Falls Sie Ihr Passwort vergessen haben, nutzen Sie bitte die Passwort-Vergessen-Funktion im Bereich der Anmeldung. ',
        'EMPTY_ITEMS_TABLE_MSG': 'Keine Produkte vorhanden',
        'EMPTY_ITEMS_TABLE_MSG_PAGE_GROUPS': 'Keine Page-Gruppen vorhanden',
        'EMPTY_ITEMS_TABLE_MSG_PAGE_TAGS': 'Keine Page-Tags vorhanden',
        'EMPTY_FILTERED_ITEMS_TABLE_MSG' : 'Es wurden keine Produkte gefunden, die mit den Suchkriterien übereinstimmen.',
        'ERROR404_TEXT' : 'Es tut uns sehr leid... die angeforderte Seite konnte nicht gefunden werden. Möchten Sie stattdessen zum Dashboard zurückkehren?',
        'ERROR404_TITLE' : '404 Error',
        'ERROR_TITLE_DEFAULT' :  'Leider ist ein Fehler aufgetreten',
        'EVALUATIONS' : 'Auswertungen',
        'FEATURE_ARTICLES_TEXT' : 'Interessante Beitrage für Sie',
        'FILTER' : 'Filter',
        'FORM_SALUTATION': 'Anrede',
        'FORM_FIRSTNAME': 'Vorname',
        'FORM_LASTNAME': 'Nachname',
        'FORM_TELEPHONE': 'Telefon',
        'FORM_EMAIL': 'E-Mail',
        'FREE' : 'Gratis',
        'FREE_INITIAL_CONSULTATION' : 'Kostenlose Erstberatung',
        "FREE_OF_CHARGE_DOWNLOAD" : 'Gratis Download',
        "FREE_OF_CHARGE_ACCESS" : 'Gratis Zugang',
        'FREE_SHOP_ANALYSIS' : 'Kostenlose Shopanalyse',
        'CONTACT_CONSULTING' : 'Kontaktiere uns',
        'FORM_LOGIN_TITLE': 'Anmeldung',
        'FORM_REGISTRATION_TITLE' : 'Registrierung',
        'REGISTER_BUTTON' : 'Jetzt registrieren',
        'GET_NEW_PASSWORD': 'Passwort anfordern',
        'GO_TO_LEARNING_CONTENT' : 'Lesson starten',
        'GO_TO_LEARNING_CONTENT_FREE' : 'Gratis Zugang',
        'BUY_LEARNING_CONTENT' : 'jetzt kaufen',
        'PURCHASED_LEARNING_CONTENT' : 'Mein Kurs',
        'PURCHASED_CHECKLIST' : 'Meine Checkliste',
        'PURCHASED_WHITEPAPER' : 'Mein Whitepaper',
        'PURCHASED_MASTERMIND' : 'Mastermind',
        'PURCHASED_SUPPORT' : 'Support',
        'PURCHASED_COACHING' : 'Coaching',
        'PURCHASED_DATE' : 'Erworben am: ',

        'NOT_PURCHASED_LEARNING_CONTENT' : 'Onlinekurs',
        'NOT_PURCHASED_CHECKLIST' : 'Checkliste',
        'NOT_PURCHASED_WHITEPAPER' : 'Whitepaper',
        'NOT_PURCHASED_MASTERMIND' : 'Mastermind',
        'NOT_PURCHASED_SUPPORT' : 'Support',
        'NOT_PURCHASED_COACHING' : 'Coaching',

        'IMPORTANCE' : 'Wichtigkeit',
        'INFO' : 'Beispiele',
        'INSERT_YOUR_NOTES' : 'Tragen Sie hier Ihre Notizen ein!',
        'MAIN_CATEGORIES' : 'Hauptkategorien',
        'MISSING_RECORDS' : 'Fehlende Datensätze',
        'MISSING_ENTRIES_FOR_TURNOVER' : 'Umsätze',
        'MISSING_ENTRIES_FOR_VISITORS' : 'Besucher',
        'MONTHS' : 'Monate',
        'MONTHLY_DATA_COLLECTION_HEADLINE': 'Monatliche Datenerfassung',
        'MONTHLY_DATA_COLLECTION_TEXT' : 'Bitte tragen Sie die folgenden Daten ein.<br/>Es werden die monatlichen Umsatz- und Besucherzahlen Ihres Onlineshops benötigt.',
        'MY_PROJECTS' : 'Meine Projekte',
        'NAV_LINK_TEXT_ADMIN_DESIGN': 'Design Anpassungen',
        'NAV_LINK_TEXT_ACADEMY' : 'Academy',
        'NAV_LINK_TEXT_ADMIN_COMPANIES' : 'Firmen',
        'NAV_LINK_TEXT_ADMIN_PRODUCT' : 'Produktverwaltung',
        'NAV_LINK_TEXT_ADMIN_USER' : 'Nutzerliste',
        'NAV_LINK_TEXT_ADMIN_PAGE_GROUPS' : 'Page-Gruppen',
        'NAV_LINK_TEXT_ADMIN_PAGE_TAGS' : 'Page-Tags',
        'NAV_LINK_TEXT_ADMIN_PAGE_TRANSFER' : 'Page-Transfer',
        'NAV_LINK_TEXT_DASHBOARD' : 'Dashboard',
        'NAV_LINK_TEXT_MY_PRODUCTS' : 'Meine Produkte',
        'NAV_LINK_TEXT_STATISTICS' : 'Statistiken',
        'NAV_LINK_TEXT_BLOG' : 'Unser Blog',
        'NAV_LINK_TEXT_AI' : 'AI-Tools',
        'NEW_PRODUCTS' : 'Neuste Produkte',
        'NEWS' : 'News',
        'NEXT_LESSON' : 'Nächste Lektion',
        'NO_ARTICLES_IN_LIST' : 'Keine Artikel vorhanden',
        'NO_TOOLS_IN_LIST' : 'Keine Tools vorhanden',
        'NO_PRODUCTS_IN_LIST' : 'noch keine Produkte erworben',
        'NO_PRODUCTS_IN_YOUR_LIST' : 'Aktuell haben Sie noch keine Produkte erworben.',
        'NO_PROJECTS_IN_YOUR_LIST' : 'Aktuell haben Sie noch keine Projekte angelegt.',
        'NOT_SET' : 'Nicht angegeben',
        'NO_VIDEO_IN_LIST' : 'Aktuell stehen noch keine Lerninhalte zur Verfügung.',
        'NOTES' : 'Notizen',
        'OPTIMIZE' : 'Optimieren',
        'PAGE_SUBTITLE' : 'Academy',
        'PAGE_TITLE' : 'Academy',
        'PASSWORD' : 'Passwort',
        'PASSWORD_FORGOTTEN_DEFAULT_TEXT' : 'Bitte geben Sie Ihre E-Mail-Adresse ein. Sie erhalten im Anschluss ein neues Passwort zugeschickt, insofern Sie bereits registriert sind.',
        'PASSWORD_FORGOTTEN_RESPONSE_TEXT' : 'Insofern Ihre E-Mail-Adresse registriert ist, erhalten Sie in den nächsten Minuten eine E-Mail mit einem Aktivierungslink, um Ihr neues Passwort zu erhalten.',
        'PLACEHOLDER_NOTICE' : 'Tragen Sie hier Ihre Notizen zur Aufgabe ein.',
        'POLICY_TERMS_TITLE' : 'Datenschutz & AGB',
        'POLICY_TITLE' : 'Datenschutzerklärung',
        'PRICE_DISCOUNT' : 'Ersparnis: {discount}%',
        'PRIORITY' : 'Priorität',
        'PRODUCT_MANAGEMENT' : 'Produktverwaltung',
        'PRODUCT_OVERVIEW' : 'Alle Produkte ansehen',
        'PRODUCT_RECOMMONDATIONS' : 'Produktempfehlungen',
        'PROJECT_INDEX' : 'Gesamtindex',
        'PW_FORGOTTEN_TITLE' : 'Passwort vergessen?',
        'PW_ACTIVATION_TITLE' : 'Passwort vergessen Aktivierung',
        'PW_ACTIVATION_SUCCESS_TEXT' : 'Ihnen wurden neue Zugangsdaten zugesendet.',
        'PW_ACTIVATION_ERROR_TEXT' : 'Der Aktivierungslink ist falsch oder abgelaufen. Bitte wiederholen Sie den Vorgang.',
        'QUICK_TIP' : 'Kurzanleitung',
        'QUICK_TIP_TITLE' : 'Kurzanleitung zur Benutzung Ihrer Checklisten',
        'READ_MORE' : 'Mehr lesen',
        'SEARCH' : 'Suche',
        'SIGN_IN' : 'Anmelden',
        'STATISTIC_HINTS_HEADLINE' : 'Hinweise zur Benutzung',
        'STATISTIC_HINTS_TEXT_1' : '<span class="font-weight-bold">Darstellung:</span> Klick auf <span class="font-weight-bold">Monate</span> zeigt die Auswertung nach Monaten. Klick auf Kalenderwochen zeigt die <span class="font-weight-bold">Kalenderwochen</span> eines Jahres.',
        'STATISTIC_HINTS_TEXT_2' : '<span class="font-weight-bold">Filter:</span> aktivieren / deaktivieren der Buttons schränkt die Ergebnisse ein.',
        'STATISTIC_HINTS_TEXT_3' : '<span class="font-weight-bold">Funktionen in den Charts:</span> Benutze die Chart-Funktionsbar, um die Ansichten zu vergößern, zu verkleinern oder zu exportieren.',
        'STATISTIC_HINTS_TEXT_4' : 'Ihre Daten bleiben immer gleich, unabhängig der ausgewählten Kategorien.',
        'STATUS' : 'Status',
        'SUB_CATEGORIES' : 'Unterkategorien',
        'SUCCESS_REGISTRATION_RESPONSE_TEXT' : 'Vielen Dank. Wir haben Ihnen eine E-Mail mit den Zugangsdaten gesendet. ',
        'SUCCESS_TITLE_DEFAULT' :  'Vielen Dank',
        'SUCCESS_TEXT_SAVE_DATA' : 'Vielen Dank! Die Daten wurden gespeichert.',
        'TASK' :  'Aufgabe',
        'TASK_TITLE_MONTHLY' : 'Monatliche Datenerfassung',
        'TASK_TITLE_WEEKLY' : 'Wöchentliche Datenerfassung',
        'TASK_TEXT_INCOMPLETE' : 'Hier finden Sie Aufgaben, die noch zu erledigen sind.',
        'TASK_TEXT_COMPLETE' : 'Vielen Dank! Sie haben aktuell alle Daten eingetragen.',
        'TERM' : 'Begriff...',
        'TERMS_TITLE' : 'AGB',
        'TODO': 'Todo',
        'TOTAL' : 'Gesamt',
        'TO_THE_CHECKLIST' : 'Zur Checkliste',
        'MORE_DETAILS' : 'Mehr Informationen',
        'USER' : 'Benutzer',
        'USER_SALUTATION' : 'Herzlich willkommen, {username}!',
        'VALID_EMAIL_ADDRESS_REQUIRED' : 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        'VALID_SURENAME_REQUIRED' : 'Bitte geben Sie Ihren Vornamen an.',
        'VALID_TELEPHONE_NUMBER_REQUIRED' : 'Bitte geben Sie eine gültige Telefonnummer ein.',
        'VIDEO_TOTALTIME' : 'Dauer: {time}',
        'WEEKLY_DATA_COLLECTION_HEADLINE' : 'Wöchentliche Datenerfassung',
        'WEEKLY_DATA_COLLECTION_TEXT' : 'Bitte tragen Sie die folgenden Daten ein.<br/>Es werden die wöchentlichen Umsatz- und Besucherzahlen Ihres Onlineshops benötigt.',
        'WEEKS' : 'Kalenderwochen',
        'YOUR_LEARNING_PROGRESS' : 'Lernfortschritt',
        'YOUR_LEARNING_PROGRESS_DESCRIPTION' : 'Hier sehen Sie, wie weit Sie bereits fortgeschritten sind.',
        'LETS_START' : 'Jetzt starten',
        'IN_PROGRESS' : 'in Bearbeitung',
        'WAITING_FOR_PAYMENT' : 'bitte Token aufladen',
        'FINISHED' : 'fertig :-)',
        'INCLUDING_TAX' : 'Alle Preise verstehen sich inklusive der gesetzlich geltenden MwSt.',
        'THANKS_TEXT' : 'Sie können diese Seite nun schließen oder zum Dashboard zurückkehren.',
        'THANKS_TITLE' : 'Vielen Dank für Ihren Kauf!',

    }
}

export {
    languages
}
